<template>
  <div class="index">
    <el-carousel :height="bannerHeight" :interval="5000" arrow="always">
      <el-carousel-item v-for="item in banner" :key="item">
        <img :src="item" alt />
      </el-carousel-item>
    </el-carousel>
    <div class="indexContent">
      <!-- 简介 -->
      <div>
        <div class="title">EIM简介</div>
        <p>
          易互动(EIM)营销策划有限公司成立于2010年8月，是一家专注于线下互动体验推广传播，客户品牌及产品营销的创意策划与执行同时兼具移动互联网技术开发和推广实力的营销服务企业，目前已成为中国西区和北区最强的整合营销传播推广公司之一。
          <br />公司总部设立于成都在北京、重庆设有分公司,其次在昆明、贵阳、西安均设有办事处，业务覆盖中国西部和北部.上百个城市。
        </p>
      </div>
      <!-- 价值观 -->
      <div>
        <div class="title">EIM价值观</div>
        <p>公司自成立以来,始终秉持实现智能营销的愿景坚持"成就客户， 成就伙伴”的价值观,服务众多国际品牌,提供人力资源服务, 市场活动策划与推广,公关/会务/培训/策划及执行,移动互联网应用开发与营销四大核心服务,帮助客户获得成功，追求客户满意,帮助伙伴不断成长,提升伙伴价值。</p>
      </div>
      <!-- 最新动态 -->
      <div>
        <div class="title">最新动态</div>
        <ul>
          <li v-for="(item, i) in brandCaseList" :key="i" @click="clckCase(item)">{{item.title}} </li>
        </ul>
      </div>
    </div>
    <!-- 图片描述 -->
    <div class="pic">
      <div class="title">7大整合力</div>
      <img src="../assets/images/index/ability.png" alt />
      <img src="../assets/images/index/declaration.png" alt />
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  data() {
    return {
      banner: [
        require('../assets/images/index/banner1.png'),
        require('../assets/images/index/banner2.png'),
        require('../assets/images/index/banner3.png')
      ],
      screenWidth: document.body.clientWidth,
      queryInfo: {
        query: '',
        page: 0,
        size: 5,
        sort: 'id,desc'
      },
      brandCaseList: []
    }
  },
  created() {
    this.brandCase()
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  methods: {
    // 品牌详情
    async brandCase() {
      const { data: res } = await this.$http.get('/api/BrandProject', {
        params: this.queryInfo
      })
      if (res.content === null) {
        return this.$message.error('获取品牌列表失败！')
      }
      this.brandCaseList = res.content
      console.log(this.brandCaseList)
    },
    // 选中线移动函数
    menuSelection(right) {
      anime({
        targets: '.navlist .selectLine',
        right: right
      })
    },
    // 判断选中线移动到指定位置
    navMenu(index) {
      if (index === 0) {
        this.menuSelection('600px')
      } else if (index === 1) {
        console.log(index)
        this.menuSelection('500px')
      } else if (index === 2) {
        this.menuSelection('400px')
      } else if (index === 3) {
        this.menuSelection('300px')
      } else if (index === 4) {
        this.menuSelection('200px')
      } else if (index === 5) {
        this.menuSelection('100px')
      } else if (index === 6) {
        this.menuSelection('0px')
      }
    },
    // 点击案例跳转
    clckCase(item) {
      this.saveNavState(4)
      // 图片
      window.sessionStorage.setItem('img', item.img)
      // 名称
      window.sessionStorage.setItem('title', item.title)
      // 描述
      window.sessionStorage.setItem('result', item.result)
      // 成果
      window.sessionStorage.setItem('remark', item.remark)
      this.$router.push({ path: '/underline' })
    },
    // 保存链接的激活状态
    saveNavState(active) {
      this.navMenu(active)
      window.sessionStorage.setItem('navActive', active)
      this.$emit('active', active)
    }
  },
  computed: {
    bannerHeight() {
      if (this.screenWidth >= 850) {
        return '550px'
      } else {
        return '300px'
      }
    }
  }
}
</script>

<style scoped>
.el-carousel {
  width: 100%;
  text-align: center;
}
.el-carousel img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  min-height: 400px;
  height: 100%;
}

.index .indexContent {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.index .indexContent > div {
  width: 320px;
  margin: 30px 22px 0px 22px;
  background-color: #fff;
  padding: 10px 10px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
}
.index .indexContent div .title {
  font-weight: 400;
  font-size: 20px;
  color: rgb(235, 89, 25);
  margin-bottom: 20px;
}
.index .indexContent div ul li {
  margin: 16px 0px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor:pointer;
}
.index .pic {
  width: 100%;
  max-width: 1100px;
  margin: 30px auto;
  padding-top: 20px;
  background-color: #fff;
  box-sizing: border-box;
}
.index .pic img {
  width: 100%;
}
.index .pic .title {
  width: 160px;
  height: 50px;
  background-color: rgba(234, 88, 24);
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0 auto 20px auto;
}
</style>
